/// <amd-module name="Test/TestPlansHubRefresh/Pivots/ExecutePivot/Redux/PointsReducer" />
import { default as produce } from "immer";
import * as ExecuteConstants from "Test/TestPlansHubRefresh/Pivots/ExecutePivot/ExecuteConstants";
import { IPointsState, ITestCaseReference } from "Test/TestPlansHubRefresh/Pivots/ExecutePivot/Redux/PointsContracts";
import { TestCase, TestPoint } from "TestPlanCommon/Contracts/TestPlan";
import { PointsActions, PointsActionsTypes } from "./PointsActions";

export function PointsReducer(state: IPointsState, action: PointsActions): IPointsState {
    state = state || ({} as IPointsState);

    return produce(state, (draftState: IPointsState) => {
        switch (action.type) {
            case PointsActionsTypes.loadInitialTestPointsSucceeded:
                draftState.testPoints = generateTestPointMap(action.payload);

                draftState.columnAndSortOrder = {
                    columnId: ExecuteConstants.TestCaseIdColumn,
                    sortOrder: undefined
                };
                break;
            case PointsActionsTypes.loadTestPointsForSelectedSuiteSucceded:
                draftState.columnAndSortOrder = {
                    ...draftState.columnAndSortOrder
                };
                if (!draftState.testPoints || action.payload.reload) {
                    draftState.testPoints = generateTestPointMap(action.payload.testPoints);
                } else {
                    const payloadTestPointsMap = generateTestPointMap(action.payload.testPoints);
                    draftState.testPoints = {
                        ...draftState.testPoints,
                        ...payloadTestPointsMap
                    };
                }
                break;

            case PointsActionsTypes.loadTestPointColumnOptionsForSelectedSuiteSucceeded:
                if (!draftState.testCases || action.payload.reload) {
                    draftState.testCases = generateColumnOptionsMap(action.payload.testCases);
                } else {
                    const payloadColumnOptionsMap = generateColumnOptionsMap(action.payload.testCases);
                    draftState.testCases = {
                        ...draftState.testCases,
                        ...payloadColumnOptionsMap
                    };
                }
                break;

            case PointsActionsTypes.unloadPreviousTestPoints:
                draftState.testPoints = undefined as any;
                break;

            case PointsActionsTypes.updateTestPointsForSelectedSuiteSucceded:
                const testPointsPayload: TestPoint[] = action.payload;

                if (testPointsPayload && testPointsPayload.length > 0) {
                    for (const testPoint of testPointsPayload) {
                        draftState.testPoints[testPoint.id] = testPoint;
                    }
                }
                break;

            case PointsActionsTypes.updateAssignTesterDropdownState:
                draftState.assignTesterDropDownState = action.payload;
                break;

            case PointsActionsTypes.updateAllTestPointsByTestCaseId:
                const allTestPoints = action.payload.testPoints;
                for (let i = 0; i < allTestPoints.length; i++) {
                    const testCaseRef: ITestCaseReference = allTestPoints[i].testCaseRef;

                    if (testCaseRef.id === action.payload.testCaseId) {
                        // update this test point
                        const testPointId = allTestPoints[i].id;

                        draftState.testPoints[testPointId].testCaseReference.name = action.payload.testCaseTitle;
                        draftState.testPoints[testPointId].testCaseReference.state = action.payload.testCaseState;
                        if (draftState.testPoints[testPointId].testCaseReference.assignedTo) {
                            draftState.testPoints[testPointId].testCaseReference.assignedTo.displayName = action.payload.testCaseAssignedTo;
                        }

                        if (action.payload.columnOptions && draftState.testCases) {
                            const testCaseWorkItem: TestCase = draftState.testCases[testPointId];
                            for (const columnOptionField in action.payload.columnOptions) {
                                const index = testCaseWorkItem.workItem.workItemFields.findIndex(key => key.hasOwnProperty(columnOptionField));
                                if (index === -1) {
                                    testCaseWorkItem.workItem.workItemFields.push({ [columnOptionField]: action.payload.columnOptions[columnOptionField] });
                                }
                                else {
                                    testCaseWorkItem.workItem.workItemFields[index] = {
                                        [columnOptionField]: action.payload.columnOptions[columnOptionField]
                                    };
                                }
                            }
                            draftState.testCases[testPointId] = testCaseWorkItem;
                        }
                    }
                }
                break;

            case PointsActionsTypes.updateColumnAndSortOrder:
                const { columnId, proposedSortOrder } = action.payload;
                draftState.columnAndSortOrder.columnId = columnId;
                draftState.columnAndSortOrder.sortOrder = proposedSortOrder;
                break;

            default:
                break;
        }
    });
}

export function generateTestPointMap(testPoints: TestPoint[]): { [id: number]: TestPoint } {
    const testPointsMap: { [id: number]: TestPoint } = {};

    if (testPoints) {
        for (const testPoint of testPoints) {
            testPointsMap[testPoint.id] = testPoint;
        }
    }

    return testPointsMap;
}

export function generateColumnOptionsMap(testCases: TestCase[]): { [id: number]: TestCase } {
    const testPointFieldsMap: { [id: number]: TestCase } = {};

    if (testCases) {
        for (const testCase of testCases) {
            for (const testPoint of testCase.pointAssignments) {
                testPointFieldsMap[testPoint.id] = testCase;
            }
        }
    }

    return testPointFieldsMap;
}

export function getTestPointsLength(testPointsMap: { [id: number]: TestPoint }) {
    return Object.keys(testPointsMap).length;
}
